enum Environment {
  Development = "development",
  Local = "local",
  Production = "production",
  Testnet = "testnet",
}

export default Environment;
